import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Last-resort fallback for a render crash. Deliberately plain: whatever broke
 * may well be the design system itself, so this leans on the smallest surface
 * that could still work.
 */
export function AppErrorFallback({ resetError }: { resetError?: () => void }) {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-4 p-6 text-center">
      <div className="flex size-12 items-center justify-center rounded-full bg-destructive/10 text-destructive">
        <AlertTriangle className="size-6" />
      </div>
      <div className="space-y-1">
        <h1 className="text-lg font-semibold">Something broke</h1>
        <p className="max-w-sm text-sm text-muted-foreground">
          The Campaign Console hit an unexpected error. It has been reported. Nothing you were
          viewing was changed.
        </p>
      </div>
      <div className="flex gap-2">
        {resetError && (
          <Button variant="outline" onClick={resetError}>
            Try again
          </Button>
        )}
        <Button onClick={() => window.location.reload()}>Reload</Button>
      </div>
    </div>
  );
}
